import { todoCharm_ariaLabel } from 'owa-locstrings/lib/strings/todocharm_arialabel.locstring.json';
import loc from 'owa-localize';
import HeaderCharm from './HeaderCharm';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { TodoPane } from 'owa-header-pane';
import { HeaderCharmType } from 'owa-header-store';
import { toggleCharm } from 'owa-header-store';

import { LazyInitializeTodoPanel } from 'owa-todos';
import * as React from 'react';

export const TodoCharmKey = 'todo';

@observer
export default class TodoCharm extends React.Component<{}, {}> {
    componentDidMount() {
        LazyInitializeTodoPanel.importAndExecute();
    }

    render() {
        return (
            <div>
                <HeaderCharm
                    key={TodoCharmKey}
                    icons={{ iconName: ControlIcons.ToDoLogoOutline }}
                    ariaLabel={loc(todoCharm_ariaLabel)}
                    title={loc(todoCharm_ariaLabel)}
                    behavior={{
                        paneComponent: isFeatureEnabled('fwk-o365shellheader') ? null : TodoPane,
                        charm: HeaderCharmType.TodoCharm,
                        onClick: this.onTodoPanelClicked,
                    }}
                />
            </div>
        );
    }

    private onTodoPanelClicked = () => {
        if (!isFeatureEnabled('fwk-o365shellheader')) {
            toggleCharm(HeaderCharmType.TodoCharm);
        }
    };
}
